import React from 'react';
import { motion } from 'framer-motion';

interface TimerDisplayProps {
  hours: number;
  minutes: number;
  seconds: number;
  milliseconds?: number;
  showMilliseconds?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'default' | 'countdown' | 'elapsed';
  className?: string;
}

const TimerDisplay: React.FC<TimerDisplayProps> = ({
  hours,
  minutes,
  seconds,
  milliseconds = 0,
  showMilliseconds = false,
  size = 'md',
  variant = 'default',
  className = '',
}) => {
  // 格式化数字为两位数
  const formatNumber = (num: number): string => {
    return num.toString().padStart(2, '0');
  };

  // 格式化毫秒为三位数
  const formatMilliseconds = (ms: number): string => {
    return ms.toString().padStart(3, '0').substring(0, 2);
  };

  // 尺寸样式
  const sizeClasses = {
    sm: 'text-2xl',
    md: 'text-4xl',
    lg: 'text-6xl',
    xl: 'text-8xl',
  };

  // 变体样式
  const variantClasses = {
    default: 'text-gray-900 dark:text-gray-100',
    countdown: 'text-primary dark:text-primary',
    elapsed: 'text-accent dark:text-accent',
  };

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={`font-mono ${sizeClasses[size]} ${variantClasses[variant]} font-bold tabular-nums ${className}`}
    >
      <span>{formatNumber(hours)}</span>
      <span className="mx-1">:</span>
      <span>{formatNumber(minutes)}</span>
      <span className="mx-1">:</span>
      <span>{formatNumber(seconds)}</span>
      {showMilliseconds && (
        <>
          <span className="mx-1">.</span>
          <span className="text-gray-500">{formatMilliseconds(milliseconds)}</span>
        </>
      )}
    </motion.div>
  );
};

export default TimerDisplay;